import React from 'react';

import { Box, ComposedElement, Spacer, Typography } from '@bcp-nextgen-dx-component-factory/design-system';
import { CallO } from '@bcp-nextgen-dx-component-factory/icons-accolade';
import { rem } from '@helpers';

import { useContactYouSoonHelper } from './contactYouSoon.helper';

export const ContactYouSoon: React.FC = () => {
	const { resources, cerise } = useContactYouSoonHelper();

	return (
		<Box
			styles={{
				flexDirection: 'row',
				backgroundColor: '#FFFFFF',
				width: rem(662),
				borderRadius: rem(16),
				padding: rem(32),
				alignItems: 'flex-start',
				justifyContent: 'center',
			}}
		>
			<ComposedElement icon={{ source: CallO }} size="large" fill={cerise} />
			<Spacer horizontal={24} />
			<Box
				styles={{
					flexDirection: 'column',
				}}
			>
				<Typography appearance="subtitle-100-04">{resources.title}</Typography>
				<Spacer vertical={8} />
				<Typography appearance="body-100-02" colorToken={'interaction-03-90'}>
					{resources.description}
				</Typography>
			</Box>
		</Box>
	);
};
